var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81 2H16.19C19.4 2 22 4.6 22 7.81V9.16C22 9.71 21.55 10.16 21 10.16H14.33C14.3266 10.136 14.3243 10.1108 14.322 10.0853C14.3177 10.0363 14.3131 9.98601 14.3 9.94C14.09 9.14 13.44 8.49 12.64 8.28C11.21 7.9 9.9 8.84 9.67 10.16H3C2.45 10.16 2 9.71 2 9.16V7.81C2 4.6 4.6 2 7.81 2ZM13.25 14.5602V12.5802C13.61 12.3602 13.89 12.0402 14.09 11.6602H21C21.55 11.6602 22 12.1102 22 12.6602V16.1902C22 19.4002 19.4 22.0002 16.18 22.0002H7.81C4.6 22.0002 2 19.4002 2 16.1902V12.6602C2 12.1102 2.45 11.6602 3 11.6602H9.91C10.11 12.0402 10.39 12.3602 10.75 12.5802V14.5602C10.75 15.2502 11.31 15.8102 12 15.8102C12.69 15.8102 13.25 15.2502 13.25 14.5602Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.12d2336250df87ccdb5c92efed649947.svg";
export { ForwardRef as ReactComponent };